import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import * as Highcharts from 'highcharts';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
NoDataToDisplay(Highcharts);
@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnDestroy {
  totalVessels: any;
  activeVessels: any;
  inactiveVessels: any;
  underPerformanceFuel: any;
  underPerformanceTime: any;
  fuelTooltipContent: any;
  timeTooltipContent: any;
  underPerformanceFuelVessels: any;
  underPerformanceTimeVessels: any;
  username: any;
  hoverTable: boolean = false;
  hoverMap: boolean = false;
  hoverBallast: boolean = false;
  hoverLaden: boolean = false;
  ballastSelectedSegment: any;
  databaseData: any;
  ladenSegments: string[] = [];
  ballastSegments: string[] = [];
  ladenSelectedSegment: any;
  ladenChart: any;
  ballastChart: any;
  ladenData: any;
  ballastData: any;
  showTooltip = false;
  tooltipTimeout: any;
  aisTableData: any[] = [];
  hoverStates: Record<CardName, boolean> = {
    laden: false,
    ballast: false,
    table: false,
    map: false,
  };

  tooltipStates: Record<CardName, boolean> = {
    laden: false,
    ballast: false,
    table: false,
    map: false,
  };
  todayDate: string = '';
  globalSpeed: number = 12.5;
  tooltipTimeouts: Partial<Record<CardName, any>> = {};
  totalVoyages: any;
  isLoadingStats: boolean = false;
  isLoadingTable: boolean = false;
  isLoadingSegments: boolean = false;
  isLoadingLadenChart: boolean = false;
  isLoadingBallastChart: boolean = false;
  storedShipNames: any;
  summaryData: any;
  fleetViewTotalRecords: any;
  homeDashboardGeneratedAt: string | null = null;
  isResyncing: boolean = false;
  Highcharts: typeof Highcharts = Highcharts;

  clientSearch: string = '';
  clientList: string[] = [];
  filteredClientList: string[] = [];
  selectedClient: string = '';
  private destroy$ = new Subject<void>();

  // Default segments for pre-fetching optimization
  private defaultLadenSegment = 'Supramax';
  private defaultBallastSegment = 'MR';
  isMapFullscreen: boolean = false;
  subusername: any;

  constructor(
    private toastr: ToastrService,
    private sharedDataService: DashboardService,
    private router: Router,
    private requestFormService: RequestFormService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    localStorage.removeItem('mapToggle');
    localStorage.removeItem('mapView');
    this.username = localStorage.getItem('username');
    this.subusername = localStorage.getItem('loginPic');
    this.loadHomeDashboard();
    this.requestFormService.themeChanged
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.refreshGraphs();
      });
    this.todayDate = new Date().toUTCString();
  }

  /** Single call replacing the old loadVesslLength/loadStats/fetchChartData(x2)/
   * loadSegments/loadAisEtaTable fan-out. All of it now comes from one
   * precomputed payload served by the home-dashboard cache. */
  loadHomeDashboard() {
    this.chartVesselMap.clear();
    this.chartVesselIndex = 1;
    this.isLoadingTable = true;
    const isEiger = this.username === 'Eiger Shipping';
    if (!isEiger) {
      this.isLoadingStats = true;
      this.isLoadingSegments = true;
      this.isLoadingLadenChart = true;
      this.isLoadingBallastChart = true;
    }

    this.sharedDataService
      .getHomeDashboard(this.username, this.subusername)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.homeDashboardGeneratedAt = data?.generated_at ?? null;
          this.applyFleetView(data?.fleet_view);
          if (!isEiger) {
            this.applyStats(data?.stats);
            this.applySegmentsAndCharts(data?.segments, data?.chart);
          }
          this.applyAisEtaTable(data?.eta_list);
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Failed to load home dashboard', err);
          this.isLoadingTable = false;
          this.isLoadingStats = false;
          this.isLoadingSegments = false;
          this.isLoadingLadenChart = false;
          this.isLoadingBallastChart = false;
          this.aisTableData = [];
          this.cdr.detectChanges();
        },
      });
  }

  /** Resync button next to the client search box — refreshes only the
   * logged-in user's own client_key (Meraki users resync Meraki's cache
   * row, EMZoil users resync EMZoil's, etc), then refetches the dashboard
   * to render the fresh data. On top of the twice-daily backend cron, for
   * whenever a user wants fresher data right now. */
  onResyncClick() {
    if (this.isResyncing) return;
    this.isResyncing = true;
    this.toastr.info('Syncing your latest data — this can take a few minutes.');

    this.sharedDataService
      .resyncHomeDashboard(this.username, this.subusername)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.toastr.success('Data synced — refreshing…');
          this.loadHomeDashboard();
          this.isResyncing = false;
        },
        error: (err) => {
          console.error('Failed to resync home dashboard', err);
          this.toastr.error('Failed to sync data. Please try again.');
          this.isResyncing = false;
        },
      });
  }

  /** True only for the 'grace' sub-user logged in under EMZoil specifically
   * — not EMZoil users in general, and not 'grace' under any other client. */
  private isEmzoilGrace(): boolean {
    return (
      this.username === 'EMZoil Shipping' &&
      this.subusername?.toLowerCase() === 'grace'
    );
  }

  private applyFleetView(fleetView: any) {
    let fleetData = fleetView?.fleet_data ?? [];
    const beforeExclusions = fleetData.length;
    if (this.subusername?.toLowerCase() === 'demo') {
      fleetData = fleetData
        .filter((item: any) => DEMO_VESSEL_PC.includes(String(item.vessel_id)))
        .map((item: any) => this.maskDemoVessel(item));
    }

    if (this.isEmzoilGrace()) {
      const allowedImos = ['9378876', '9399480', '9438406', '9432048'];
      fleetData = fleetData.filter((item: any) =>
        allowedImos.includes(String(item.imo_number ?? item.imo ?? item.vessel_id))
      );
    }
    const excludedCount = beforeExclusions - fleetData.length;

    this.summaryData = fleetData;
    // Cache only ships the first page (100 rows); total_records is the true
    // count across the client's whole fleet, used to drive the paginator.
    // Subtracting excludedCount keeps the displayed total honest for grace
    // — EMZoil's fleet is well under 100 vessels, so page 1 always contains
    // every vessel grace's exclusions could apply to.
    const rawTotal = fleetView?.total_records ?? fleetData.length;
    this.fleetViewTotalRecords = Math.max(0, rawTotal - excludedCount);
    this.storedShipNames = fleetData?.length;
    this.isLoadingTable = false;
  }

  /** EMZoil-grace only: recomputes the stat cards live, scoped to exactly
   * the vessel names grace can see (post Hanna/Phosphor exclusion), since
   * the cached stats aggregate has no awareness of that sub-user rule. */
  private loadGraceScopedStats() {
    const vesselNames = (this.summaryData || [])
      .map((item: any) => item.shipName)
      .filter((name: string) => !!name);

    if (!vesselNames.length) {
      this.applyStats({});
      return;
    }

    this.isLoadingStats = true;
    this.sharedDataService
      .getLookerStats(this.username, { vessel_names: vesselNames })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (stats: any) => {
          this.applyStats(stats);
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Failed to load grace-scoped stats', err);
          this.isLoadingStats = false;
          this.cdr.detectChanges();
        },
      });
  }

  private applyStats(stats: any) {
    stats = stats ?? {};
    this.totalVoyages = stats.total_voyages;
    this.totalVessels = stats.total_vessels;
    this.activeVessels = stats.active_vessels;
    this.inactiveVessels = stats.inactive_vessels;
    this.underPerformanceFuel = stats.underperformance_fuel;
    this.underPerformanceTime = stats.underperformance_time;

    this.underPerformanceFuelVessels = stats.fuel_underperf_vessels ?? [];
    this.underPerformanceTimeVessels = stats.time_underperf_vessels ?? [];

    this.fuelTooltipContent = this.underPerformanceFuelVessels.join(', ');
    this.timeTooltipContent = this.underPerformanceTimeVessels.join(', ');
    this.isLoadingStats = false;
  }
  private demoVesselMap = new Map<string, string>();
  private demoVesselIndex = 1;
  private maskDemoVessel(item: any): any {
    const imo = String(item.imo_number ?? item.imo ?? item.vessel_id ?? '');

    if (!this.demoVesselMap.has(imo)) {
      this.demoVesselMap.set(imo, `Vessel ${this.demoVesselIndex++}`);
    }

    return {
      ...item,
      vessel_name: this.demoVesselMap.get(imo),
      shipName: this.demoVesselMap.get(imo),
      imo: 'XXXXXXX',
      imo_number: 'XXXXXXX',
      vessel_id: 'XXXXXXX',
    };
  }
  private applySegmentsAndCharts(segments: any, chart: any) {
    this.ladenSegments = (segments?.laden || []).filter((s: string) => !!s);
    this.ballastSegments = (segments?.ballast || []).filter((s: string) => !!s);
    this.isLoadingSegments = false;

    const laden = chart?.laden ?? { segment: null, data: [] };
    const ballast = chart?.ballast ?? { segment: null, data: [] };

    this.ladenSelectedSegment = laden.segment || this.defaultLadenSegment;
    this.ballastSelectedSegment = ballast.segment || this.defaultBallastSegment;

    this.ladenData = (laden.data ?? []).map((item: any) => ({
      ...item,
      vessel: this.maskChartVesselName(item.vessel),
    }));

    this.ballastData = (ballast.data ?? []).map((item: any) => ({
      ...item,
      vessel: this.maskChartVesselName(item.vessel),
    }));
    this.ladenChart = this.createChart(
      `${this.ladenSelectedSegment || ''} Laden Vessel Performance`,
      this.ladenData,
    );
    this.ballastChart = this.createChart(
      `${this.ballastSelectedSegment || ''} Ballast Vessel Performance`,
      this.ballastData,
    );
    this.isLoadingLadenChart = false;
    this.isLoadingBallastChart = false;
  }

  private applyAisEtaTable(etaList: any) {
    const rows =
      etaList?.success && Array.isArray(etaList.data) ? etaList.data : [];
    let filteredData = rows;
    if (this.subusername?.toLowerCase() === 'demo') {
      filteredData = filteredData
        .filter((item: any) => DEMO_VESSEL_PC.includes(String(item.imo)))
        .map((item: any) => this.maskDemoVessel(item));
    }

    if (this.isEmzoilGrace()) {
      const allowedImos = ['9378876', '9399480', '9438406', '9432048'];
      filteredData = filteredData.filter((item: any) =>
        allowedImos.includes(String(item.imo))
      );
    }

    this.aisTableData = filteredData.map((item: any) => {
      const row = {
        vessel_name: item.vessel_name,
        imo: item.imo,

        // Port Said
        portSaidEta: item?.ports?.['Port Said']?.eta || '-',
        portSaidDistance: item?.ports?.['Port Said']?.distance_nm || 0,

        // Novorossiysk
        novoEta: item?.ports?.['Novorossiysk']?.eta || '-',
        novoDistance: item?.ports?.['Novorossiysk']?.distance_nm || 0,

        // Primorsk
        primorskEta: item?.ports?.['Primorsk']?.eta || '-',
        primorskDistance: item?.ports?.['Primorsk']?.distance_nm || 0,

        // AIS
        lastAis: item?.last_position?.timestamp || '-',

        speed: this.globalSpeed || item?.last_position?.speed || 12.5,

        lat: item?.last_position?.lat || '-',

        lng: item?.last_position?.lon || '-',
      };

      this.recalculateETA(row);
      return row;
    });
  }

  applyGlobalSpeed() {
    this.aisTableData.forEach((row) => {
      row.speed = this.globalSpeed;
      this.recalculateETA(row);
    });
  }

  recalculateETA(row: any) {
    if (!row.speed || row.speed <= 0) return;
    const lastAisTime = new Date(row.lastAis).getTime();
    if (isNaN(lastAisTime)) return;

    if (row.portSaidDistance) {
      const hours = row.portSaidDistance / row.speed;
      row.portSaidEta = new Date(
        lastAisTime + hours * 3600 * 1000,
      ).toISOString();
    }
    if (row.novoDistance) {
      const hours = row.novoDistance / row.speed;
      row.novoEta = new Date(lastAisTime + hours * 3600 * 1000).toISOString();
    }
    if (row.primorskDistance) {
      const hours = row.primorskDistance / row.speed;
      row.primorskEta = new Date(
        lastAisTime + hours * 3600 * 1000,
      ).toISOString();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  filterClients() {
    const search = this.clientSearch.toLowerCase();

    this.filteredClientList = this.clientList.filter((client: string) =>
      client.toLowerCase().includes(search),
    );
  }
  selectClient(client: string) {
    this.selectedClient = client;
    this.clientSearch = client;

    // Optional: close dropdown
    this.filteredClientList = [];

    // If needed (your error shows missing functions)
    // comment these if not implemented
    // this.loadPcBenchmarkingChart();
    // this.loadTcpBenchmarkingChart();
  }
  refreshGraphs() {
    if (this.ladenSelectedSegment)
      this.fetchChartData('Laden', this.ladenSelectedSegment);
    if (this.ballastSelectedSegment)
      this.fetchChartData('Ballast', this.ballastSelectedSegment);
  }
  // ─── Legacy: fetched all 22k rows at once ─────────────────────────────────
  // loadData() {
  //   this.sharedDataService.getDatabase().subscribe((data) => {
  //     if (!Array.isArray(data)) {
  //       data = Object.values(data);
  //       const clientFilters: { [key: string]: (item: any) => boolean } = {
  //         'Eiger Shipping': (item) => item.client_name === 'client',
  //         'Zeronorth ZN': (item) => item.client_name === 'ZeroNorth',
  //         'Elite Shipping': (item) => item.client_name === 'ELITE TANKSHIP DMCC',
  //         'Bunge Shipping': (item) => item.client_name === 'Bunge',
  //         'Alcor Shipping': (item) => item.client_name === 'ALCOR CHARTERING DMCC',
  //         'EMZoil Shipping': (item) => item.client_name === 'EMZ OIL',
  //       };
  //       if (this.username === 'Meraki - Operations') {
  //         data = data;
  //       } else if (clientFilters[this.username]) {
  //         data = data.filter(clientFilters[this.username]);
  //       }
  //     }
  //     this.getDataCounts(data);
  //     this.databaseData = data;
  //     this.loadSegments();
  //     this.isDataLoaded = true;
  //   });
  // }
  // ──────────────────────────────────────────────────────────────────────────

  /** On-demand fetch for ONE chart render */
  fetchChartData(condition: string, segment: string) {
    if (condition === 'Laden') this.isLoadingLadenChart = true;
    if (condition === 'Ballast') this.isLoadingBallastChart = true;

    this.sharedDataService
      .getLookerChartData(this.username, segment)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any[]) => {
          const chartTitle = `${segment || ''} ${condition} Vessel Performance`;

          // Handle empty response gracefully
          if (!data || data.length === 0) {
            if (condition === 'Laden') {
              this.ladenChart = this.createChart(chartTitle, []);
              this.ladenData = [];
              this.isLoadingLadenChart = false;
            } else if (condition === 'Ballast') {
              this.ballastChart = this.createChart(chartTitle, []);
              this.ballastData = [];
              this.isLoadingBallastChart = false;
            }
            return;
          }

          // Normalize results
          const normalized = data.map((item) => ({
            ...item,
            vessel_name: this.maskChartVesselName(item.vessel_name),
            voyage_type: item.voyage_type === 'True' ? 'Laden' : 'Ballast',
          }));

          const result = this.calculateAverages(normalized);

          if (condition === 'Laden') {
            this.ladenChart = this.createChart(chartTitle, result);
            this.ladenData = result;
            this.isLoadingLadenChart = false;
          } else if (condition === 'Ballast') {
            this.ballastChart = this.createChart(chartTitle, result);
            this.ballastData = result;
            this.isLoadingBallastChart = false;
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error(
            `Failed to load chart data for ${condition} ${segment}`,
            err,
          );
          if (condition === 'Laden') this.isLoadingLadenChart = false;
          if (condition === 'Ballast') this.isLoadingBallastChart = false;
          this.cdr.detectChanges();
        },
      });
  }

  /** Legacy: no longer used for on-demand pattern */
  // loadChartData() { ... }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  onCardMouseEnter(cardName: CardName) {
    clearTimeout(this.hoverLeaveTimeout);
    this.hoverStates[cardName] = true;
    this.tooltipStates[cardName] = true;

    clearTimeout(this.tooltipTimeouts[cardName]);
    this.tooltipTimeouts[cardName] = setTimeout(() => {
      this.tooltipStates[cardName] = false;
    }, 100000);
  }
  hoverLeaveTimeout: any = null;
  onCardMouseLeave(cardName: CardName) {
    this.hoverStates[cardName] = false;
    this.tooltipStates[cardName] = false;
  }

  onSegmentChange(condition: string) {
    let segment = '';
    if (condition === 'Laden') {
      segment = this.ladenSelectedSegment;
    } else if (condition === 'Ballast') {
      segment = this.ballastSelectedSegment;
    }
    if (segment) {
      // this.fetchChartData(condition, segment);
    }
  }
  getDataCounts(data: any) {
    this.totalVoyages = data.length;
    const uniqueVesselsMap = new Map<string, any>();
    data.forEach((vessel: any) => {
      if (!uniqueVesselsMap.has(vessel.vessel_name)) {
        uniqueVesselsMap.set(vessel.vessel_name, vessel);
      }
    });
    const uniqueVessels = Array.from(uniqueVesselsMap.values());
    this.totalVessels = uniqueVessels.length;
    this.activeVessels = uniqueVessels.filter(
      (vessel: any) => vessel.vessel_status === 'True',
    ).length;
    this.inactiveVessels = uniqueVessels.filter(
      (vessel: any) => vessel.vessel_status !== 'True',
    ).length;
    this.underPerformanceFuel = data.filter((vessel: any) => {
      const totalFuelLg =
        (vessel.total_fuel_gain || 0) - (vessel.total_fuel_loss || 0);
      return totalFuelLg < 0;
    }).length;
    this.underPerformanceTime = data.filter((vessel: any) => {
      const totalTimeLg =
        (vessel.total_time_gain || 0) - (vessel.total_time_loss || 0);
      return totalTimeLg < 0;
    }).length;
    this.underPerformanceFuelVessels = data
      .filter((vessel: any) => {
        const totalFuelLg =
          (vessel.total_fuel_gain || 0) - (vessel.total_fuel_loss || 0);
        return totalFuelLg < 0;
      })
      .slice(0, 5) // Limit to 5 vessels
      .map((vessel: any) => vessel.vessel_name); // Assuming vessel has a 'name' property

    this.underPerformanceTimeVessels = data
      .filter((vessel: any) => {
        const totalTimeLg =
          (vessel.total_time_gain || 0) - (vessel.total_time_loss || 0);
        return totalTimeLg < 0;
      })
      .slice(0, 5) // Limit to 5 vessels
      .map((vessel: any) => vessel.vessel_name); // Assuming vessel has a 'name' property

    this.fuelTooltipContent =
      this.underPerformanceFuelVessels.length > 5
        ? this.underPerformanceFuelVessels.slice(0, 5).join(', ') + ', ...'
        : this.underPerformanceFuelVessels.join(', ');

    this.timeTooltipContent =
      this.underPerformanceTimeVessels.length > 5
        ? this.underPerformanceTimeVessels.slice(0, 5).join(', ') + ', ...'
        : this.underPerformanceTimeVessels.join(', ');
  }
  calculateAverages(data: any) {
    const groupedData: {
      [key: string]: {
        avgSpeeds: number[];
        avgDailyCons: number[];
        segmentAvgSpeed: number;
        segmentAvgDailyCons: number;
        totalDistance: number;
      };
    } = {};

    // Group data by vessel_name (segment and condition are now handled by API)
    data.forEach((entry: any) => {
      const key = entry.vessel_name;
      if (!groupedData[key]) {
        groupedData[key] = {
          avgSpeeds: [],
          avgDailyCons: [],
          segmentAvgSpeed: entry.segment_avg_speed,
          segmentAvgDailyCons: entry.segment_avg_daily_cons,
          totalDistance: 0,
        };
      }
      groupedData[key].avgSpeeds.push(entry.avg_speed);
      groupedData[key].avgDailyCons.push(entry.total_avg_daily_cons);
      groupedData[key].totalDistance += entry.total_distance || 0;
    });

    // We use the segment averages directly from the first entry of each group
    // (backend ensures they are consistent across the segment result set)
    const firstGroup = Object.values(groupedData)[0];
    const segmentAvgSpeed = firstGroup
      ? Number(firstGroup.segmentAvgSpeed?.toFixed(2))
      : 0;
    const globalSegmentAvgCons = firstGroup
      ? Number(firstGroup.segmentAvgDailyCons?.toFixed(2))
      : 0;

    const results: AverageResult[] = [];

    Object.entries(groupedData).forEach(([vessel, values]) => {
      const averageSpeed = Number(
        (
          values.avgSpeeds.reduce((sum, speed) => sum + speed, 0) /
          values.avgSpeeds.length
        ).toFixed(2),
      );
      const averageDailyCons = Number(
        (
          values.avgDailyCons.reduce((sum, cons) => sum + cons, 0) /
          values.avgDailyCons.length
        ).toFixed(2),
      );

      // Linear Scaling: Cons_Normalized = (Vessel_Cons / Vessel_Speed) * Segment_Avg_Speed
      // This allows comparing all vessels at the same baseline speed.
      const consAtAvgSegSpeed = Number(
        (
          ((averageDailyCons ?? 0) / (averageSpeed || 1)) *
          (segmentAvgSpeed ?? 0)
        ).toFixed(2),
      );

      results.push({
        vessel,
        segment: '', // Segment is implicit in the current fetch
        averageSpeed,
        averageDailyCons,
        segmentAvgSpeed,
        consAtAvgSegSpeed,
        average: globalSegmentAvgCons, // The global average line should be the segment avg cons
        totalDistance: values.totalDistance,
      });
    });

    return results;
  }
  private chartVesselMap = new Map<string, string>();
  private chartVesselIndex = 1;
  private maskChartVesselName(vesselName: any): string {
    const actualName = String(vesselName ?? '').trim();

    if (!actualName) {
      return 'Vessel';
    }

    // Mask only for demo loginPic
    if (this.subusername?.toLowerCase() !== 'demo') {
      return actualName;
    }

    if (!this.chartVesselMap.has(actualName)) {
      this.chartVesselMap.set(actualName, `Vessel ${this.chartVesselIndex++}`);
    }

    return this.chartVesselMap.get(actualName)!;
  }
  createChart(title: string, data: any[]) {
    const trimmedData = (data || []).slice(0, 10);

    const hasData = trimmedData.length > 0;

    const vesselNames = hasData ? trimmedData.map((item) => item.vessel) : [];

    const averageValue = hasData
      ? Number(
          (
            trimmedData.reduce((sum, item) => sum + item.consAtAvgSegSpeed, 0) /
            trimmedData.length
          ).toFixed(2),
        )
      : 0;

    const segAvgSpeed = hasData
      ? Number(
          (
            trimmedData.reduce((sum, item) => sum + item.segmentAvgSpeed, 0) /
            trimmedData.length
          ).toFixed(2),
        )
      : 0;

    const consumptionData = hasData
      ? trimmedData.map((item) => ({
          y: item.consAtAvgSegSpeed,
          totalDistance: item.totalDistance * 0.621371,
        }))
      : [];
    const labelColor = this.isDarkMode() ? '#f5f5f5' : '#0088B5';

    return new Chart({
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        height: null,
        spacingTop: 10,
        spacingBottom: 10,
        spacingLeft: 10,
        spacingRight: 10,
        marginTop: 60,
        marginBottom: 80,
      },

      exporting: { enabled: false },

      lang: {
        noData: 'No Data Available',
      },

      noData: {
        style: {
          fontFamily: 'Poppins, sans-serif',
          fontSize: '14px',
          fontWeight: '500',
          color: labelColor,
        },
        position: {
          align: 'center',
          verticalAlign: 'middle',
        },
      },

      title: {
        text: title,
        style: {
          fontFamily: 'Poppins, sans-serif',
          color: labelColor,
          fontSize: '10px',
        },
      },

      xAxis: {
        categories: vesselNames,
        title: {
          text: 'Vessel Names',
          style: {
            fontFamily: 'Poppins, sans-serif',
            color: labelColor,
            fontSize: '10px',
          },
        },
        labels: {
          rotation: -20,
          formatter: function () {
            const name = this.value as string;
            return name?.length > 10 ? name.substring(0, 10) + '...' : name;
          },
          style: {
            fontSize: '6px',
            fontFamily: 'Poppins, sans-serif',
            color: labelColor,
          },
        },
      },

      yAxis: {
        min: 0,
        title: {
          text: 'Consumption(MT)',
          style: {
            fontFamily: 'Poppins, sans-serif',
            color: labelColor,
            fontSize: '10px',
          },
        },
        labels: {
          style: {
            fontFamily: 'Poppins, sans-serif',
            color: labelColor,
            fontSize: '6px',
          },
        },

        plotLines: hasData
          ? [
              {
                color: '#ff9e32',
                value: averageValue,
                width: 2,
                dashStyle: 'Dash',
                zIndex: 5,
                label: {
                  text: `Average: ${averageValue} MT`,
                  align: 'right',
                  style: {
                    color: '#ff9e32',
                    fontSize: '6px',
                    fontFamily: 'Poppins, sans-serif',
                  },
                },
              },
              {
                color: '#fafd6e',
                value: segAvgSpeed,
                width: 2,
                dashStyle: 'Dash',
                zIndex: 5,
                label: {
                  text: `Segment Avg Speed: ${segAvgSpeed} Kts`,
                  align: 'right',
                  style: {
                    color: '#fafd6e',
                    fontSize: '6px',
                    fontFamily: 'Poppins, sans-serif',
                  },
                },
              },
            ]
          : [],
      },

      tooltip: {
        formatter: function () {
          const point = this.point as Highcharts.Point & {
            totalDistance?: number;
          };
          const dist = point.totalDistance
            ? point.totalDistance.toFixed(2)
            : 'N/A';

          if (this.series.name === 'Consumption') {
            return `
        <b>${this.x}</b><br>
        <span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y} MT</b><br>
        <span style="color:red">\u25CF</span> Average: <b>${averageValue} MT</b><br>
         <span style="color:#9d0023">\u25CF</span> Segment Avg Speed: <b>${segAvgSpeed}Kts </b><br>
        <span style="color:blue">\u25CF</span> Total Distance: <b>${dist} miles</b>
      `;
          } else {
            return `
        <b>${this.x}</b><br>
        <span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y} MT</b><br>
        <span style="color:blue">\u25CF</span> Total Distance: <b>${dist} miles</b>
      `;
          }
        },
      },

      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            allowOverlap: true,
            style: {
              fontFamily: 'Poppins, sans-serif',
              color: labelColor,
              fontSize: '6px',
              textOutline: 'none',
            },
          },
        },
      },

      legend: {
        enabled: true,
        itemStyle: {
          fontFamily: 'Poppins, sans-serif',
          color: labelColor,
          fontSize: '6px',
        },
      },

      credits: { enabled: false },

      // 🔥 KEY PART
      series: hasData
        ? [
            {
              name: 'Consumption',
              type: 'column',
              color: '#104177',
              data: consumptionData,
            },
            {
              name: 'Average',
              type: 'line',
              data: Array(consumptionData.length).fill(averageValue),
              color: '#ff9e32',
              dashStyle: 'Dash',
              marker: { enabled: false },
            },
            {
              name: 'Segment Avg Speed',
              type: 'line',
              data: Array(consumptionData.length).fill(segAvgSpeed),
              color: '#fafd6e',
              dashStyle: 'Dash',
              marker: { enabled: false },
            },
          ]
        : [],
    });
  }
  onGraphClick() {
    localStorage.setItem('mapToggle', 'true');
    this.router.navigate(['/vp-database'], {
      queryParams: { source: 'fleet-performance' },
    });
  }
  onTableClick() {
    this.router.navigate(['/vp-CharterpartyTable']);
  }
  onMapClick() {
    localStorage.setItem('mapView', 'true');
    this.router.navigate(['/vp-updateTable']);
  }
  showTableTooltip() {
    this.tooltipStates.table = true;
  }

  hideTableTooltip() {
    this.tooltipStates.table = false;
  }

  openMapFullscreen() {
    this.isMapFullscreen = true;

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  closeMapFullscreen() {
    this.isMapFullscreen = false;

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }
}
interface AverageResult {
  vessel: string;
  segment: string;
  averageSpeed: number;
  averageDailyCons: number;
  segmentAvgSpeed: number;
  consAtAvgSegSpeed: number;
  average: number;
  totalDistance?: number;
}
type CardName = 'laden' | 'ballast' | 'table' | 'map';
